module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_44.dot-80ba40eaebf9fdeffe794d83297fc5bd.svg";